import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  getSubscriptionListAction,
  setScreenNameAction,
  setSubscriptionListAction,
} from 'root-redux/actions/common'
import { selectSubscriptionList } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { setSelectedSubscriptionAction } from 'modules/purchase/redux/actions/common'

import { ScreenName, SubscriptionListType } from 'root-constants'

import { useApplovinViewItemEvent } from './useApplovinViewItemEvent'

type TParams = {
  enabled?: boolean
  tags: string
  screenName?: ScreenName
  subscriptionType: SubscriptionListType
}

export const useGetSubscriptions = ({
  enabled = true,
  tags,
  screenName,
  subscriptionType,
}: TParams) => {
  const dispatch: TAppDispatch = useDispatch()
  const subscriptionsList = useSelector(selectSubscriptionList)

  useApplovinViewItemEvent({ enabled: !!screenName })

  useEffect(() => {
    if (!screenName) return

    dispatch(setScreenNameAction(screenName))
  }, [dispatch, screenName])

  useEffect(() => {
    if (!enabled) return

    dispatch(setSubscriptionListAction([]))
    dispatch(getSubscriptionListAction(subscriptionType, tags))
  }, [dispatch, enabled, subscriptionType, tags])

  useEffect(() => {
    if (!enabled) return

    const defaultSubscription =
      subscriptionsList.find(({ isDefault }) => !!isDefault) ||
      subscriptionsList[0]

    if (!defaultSubscription) {
      return
    }

    dispatch(setSelectedSubscriptionAction(defaultSubscription))
  }, [dispatch, enabled, subscriptionsList])
}
